import axios from "../../axios-instance";
import cookies from 'js-cookie';
import {getPageData} from 'modules/page-events';
import {createFormData} from 'modules/helpers/form-data-helper';
import {showMessage} from 'modules/helpers/login-flow-pages-helper';

const pageData = getPageData('page-forgot-data'),
    sendButton = document.getElementById('send-button'),
    usernameInput = document.getElementById('username');

const handleForgot = () => {
  sendButton.textContent = pageData.buttonSendingText;
  sendButton.setAttribute('disabled', 'disabled');

  const errBlock = document.getElementById('err-block'),
      msgBlock = document.getElementById('msg-block');

  axios.post('/auth/forgot', createFormData({'username': usernameInput.value}))
      .then(response => {
        if (response.data.is_error){
          msgBlock.classList.add('infobox--hidden');
          showMessage('err-block', 'err-field', response.data.errors.username);
          sendButton.textContent = pageData.buttonSendText;
        } else {
          errBlock.classList.add('infobox--hidden');
          showMessage('msg-block', 'msg-field', pageData.messageText);
          sendButton.textContent = pageData.buttonResendText;
        }
      })
      .catch(() => {
      })
      .then(() => {
        sendButton.removeAttribute('disabled');
      });
}

const initUsername = () => {
  const username = cookies.get('login-username');
  if (username) {
    usernameInput.value = username;
  }
  usernameInput.focus();
}

const initBasePageEvents = () => {
  document.getElementById('forgot-form').addEventListener('submit', e => {
    e.preventDefault();
    handleForgot();
  });
  sendButton.removeAttribute('disabled');

  initUsername();
}

initBasePageEvents();
